var _messageTimeouts;

import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
import { messageTypes } from "./message-types";
var messageTimeouts = (_messageTimeouts = {}, _messageTimeouts[messageTypes.INFO] = 2000, _messageTimeouts[messageTypes.WARNING] = 5000, _messageTimeouts[messageTypes.ERROR] = false, _messageTimeouts[messageTypes.SUCCESS] = 2000, _messageTimeouts);
messageTimeouts.ALL = _valuesInstanceProperty(_).call(_, messageTimeouts);
export default messageTimeouts;
//# sourceMappingURL=timeouts.js.map